/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('MaInfoBoxCtrl',['$rootScope','$scope','MainService','NetworkService', function ($rootScope, $scope, MainService, NetworkService) {
        $scope.user = {}
        
        $rootScope.$on("renderMaInfoBox", function(e, data){
            NetworkService.getMitarbeiterDetails(data, function(data){
                $scope.user = data
                
            })
            
        })
}])